import React, { useEffect, useState } from 'react';
import { Select } from 'antd';
import { useOpCode } from 'hooks';
import { selectBoxFilterOption } from 'utils/form-utils';

export interface OpSelectBox {
  codeValue?: number|undefined;
  boxSize?: string;
  isAll?: boolean;
  onChangeSelect?: (value: string | number, option?:any) => void;
}

const OpCode = ({
  codeValue,
  boxSize = '150px',
  isAll = true,
  onChangeSelect
}: OpSelectBox): React.ReactElement => {
    
  /* ======================================================
  * States
  * ====================================================== */
  const [options, setOptions] = useState<any[]>([]);


  /* ======================================================
  * hooks
  * ====================================================== */
  const { opCodeList } = useOpCode({});  

  /* ======================================================
   * effects
   * ====================================================== */

  useEffect(() => {
    const opts : any[] = [];
    if (isAll) opts.push({value: 'A', label: '전체'})

    if (opCodeList) {
      opCodeList.forEach((item) => {
        opts.push({value: item.value, label: item.label})  
      })
    }

    setOptions(opts);
    
  }, [opCodeList]);

  /* ======================================================
   * render items
   * ====================================================== */
  return (
    <Select 
      style={{width:boxSize }} 
      value={codeValue}
      placeholder={'운영자'}
      onSelect={onChangeSelect}
      virtual={false}
      showSearch={true} 
      options={options}       
      optionFilterProp="label"     
      filterOption={selectBoxFilterOption}
     
    /> 
  );
};

export default OpCode;
